var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6136_78018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6666C18.2091 18.6666 20 16.8758 20 14.6666C20 12.4575 18.2091 10.6666 16 10.6666C13.7909 10.6666 12 12.4575 12 14.6666C12 16.8758 13.7909 18.6666 16 18.6666Z",
    stroke: "#080808",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5433 22.2093L17.886 27.8666C17.386 28.3662 16.7081 28.6467 16.0013 28.6467C15.2945 28.6467 14.6167 28.3662 14.1167 27.8666L8.45799 22.2093C6.96628 20.7175 5.95044 18.8169 5.53891 16.7478C5.12737 14.6787 5.33864 12.534 6.14599 10.5849C6.95334 8.6359 8.32052 6.97003 10.0746 5.79799C11.8287 4.62594 13.891 4.00037 16.0007 4.00037C18.1103 4.00037 20.1726 4.62594 21.9267 5.79799C23.6808 6.97003 25.048 8.6359 25.8553 10.5849C26.6627 12.534 26.8739 14.6787 26.4624 16.7478C26.0509 18.8169 25.035 20.7175 23.5433 22.2093V22.2093Z",
    stroke: "#080808",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6136_78018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.1b9a5484a6b525cea2843ee62a9a3d85.svg";
export { ForwardRef as ReactComponent };